// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export default (obj: any): boolean => {
    return obj && Object.keys(obj).length === 0;
};
